var map = {
	"./drive-sm.png": "eMK6",
	"./fundamentals-sm.png": "dm87",
	"./hello-hr-sm.png": "iuJz",
	"./job-description-generator-sm.png": "NEWQ",
	"./live-hr-advice-sm.png": "12AH",
	"./policy-manual-wizard-sm.png": "UORU",
	"./surveys-sm.png": "1Ie8",
	"./training-sm.png": "qYDw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ds2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons ^\.\/.*\-sm\.png$
// module id = ds2f
// module chunks = 0